import { aludraApi } from 'api/axios'
import { mdl12Urls } from './mdl12.urls'

export const uploadFile = async (payload, { onProgress, ...config } = {}) => {
  return aludraApi.post(mdl12Urls.uploadFileURL, payload, {
    ...config,
    onUploadProgress: ({ loaded, total }) => {
      if (!onProgress || !total) return

      onProgress(Math.round((loaded * 100) / total))
    },
  })
}
